var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconNodeEdit = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "1.5", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-476.311 -461)" },
                React.createElement("g", { transform: "translate(485 461)" },
                    React.createElement("path", { d: "M3.4,8.8h9c1.1,0,1.9,0.9,1.9,1.9v8.7c0,1.1-0.9,1.9-1.9,1.9h-9c-1.1,0-1.9-0.9-1.9-1.9v-8.7\n\t\t\tC1.4,9.6,2.3,8.8,3.4,8.8z" })),
                React.createElement("path", { d: "M481.9,478.7l2.5-2.5l-2.5-2.5" }),
                React.createElement("path", { d: "M504.9,476.2h-5.1" }),
                React.createElement("path", { d: "M482.2,476.2h-4.4" })))));
});
export default IconNodeEdit;
//# sourceMappingURL=IconGraphNode.js.map